import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from "@mui/material";
import { Cancel } from "@mui/icons-material";
import { createLanguage, editLanguage } from "../../store/language/language.action";
import { CLOSE_LANGUAGE_DIALOG } from "../../store/language/language.type";

const LanguageDialog = (props) => {
  const { dialog: open, dialogData } = useSelector(state => state.language);
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [error, setError] = useState({});

  const dispatch = useDispatch();

  useEffect(() => {
    if (dialogData) {
      setName(dialogData?.name || "");
      setCode(dialogData?.code || "");
    } else {
      setName("");
      setCode("");
    }
  }, [dialogData, open]);

  const handleClose = () => dispatch({ type: CLOSE_LANGUAGE_DIALOG });

  const handleSubmit = () => {
    let err = {};
    if (!name) err.name = "Language Name is required!";
    if (Object.keys(err).length > 0) return setError(err);

    const formData = { name, code };

    if (dialogData?._id) {
      // Correct order (formData, id)
      props.editLanguage(formData, dialogData._id);
    } else {
      props.createLanguage(formData);
    }

    handleClose();
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleSubmit();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        <span className="modal-title font-weight-bold h4">
          {dialogData ? "Edit Language" : "Add Language"}
        </span>
        <IconButton style={{ position: "absolute", right: 0 }} onClick={handleClose}>
          <Tooltip title="Close">
            <Cancel />
          </Tooltip>
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <div className="form-group mb-3">
          <label className="mb-1">Language Name</label>
          <input
            type="text"
            className="form-control"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              if (!e.target.value) setError({ ...error, name: "Name is required" });
              else setError({ ...error, name: "" });
            }}
            onKeyPress={handleKeyPress}
          />
          {error.name && <small className="text-danger">{error.name}</small>}
        </div>

        <div className="form-group mb-3">
          <label className="mb-1">Language Code (Optional)</label>
          <input
            type="text"
            className="form-control"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            onKeyPress={handleKeyPress}
          />
        </div>

        <div className="mt-3 float-right">
          <button className="btn btn-info px-3" onClick={handleSubmit}>
            {dialogData ? "Update" : "Add"}
          </button>
          <button className="btn btn-danger px-3 ml-2" onClick={handleClose}>
            Close
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default connect(null, { createLanguage, editLanguage })(LanguageDialog);
